import BillLading from '@/components/BillLading/BillLading';
import pdf from 'vue-pdf'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
export default {
    name: "BillOfLoadingDetail",
    conditionData:'',
    created: function () {
        this.init();
    },
    components:{
        BillLading,
        pdf
    },
    data() {
        return {
            edit:true,
            showPdf :true,
            pdfSrc: '',
            numPages: 0,
            progress: 0,
            progressShow: true,
            imageType:'',
            billLadingData: {
            },
            // 提单文件列表
            billOfLoadingFileList: [],
            // 打印申请列表
            billApplyList: [],
            // 提单文件列表
            billInvalidApplyList: [],
            billDetailForm: {
                signer:'',
                issuingParty_label:'',
                billingFee:'',
                issuingTime:'',
                portOfDischarge:'',
                billAdditionalDescription:'',
                billAdditionalDescriptionOfSend:'',
                stdContainerNumber:'',
                imageType:'',
                payment:''
            },
            billOfLoadingInfo:{},
            // 公司下拉列表
            companyList: [],
            // 出单费下拉列表
            costList:[]
        }
    },
    computed: {
        singCompanyList(){
            if(this.billDetailForm.issuingParty_label && this.billDetailForm.signer){
                if(this.billDetailForm.issuingParty_label === this.billDetailForm.signer){
                    const id = this.billDetailForm.issuingParty_label;
                    return [{id:id, companyName: this.getCompanyName(id)}]
                }else{
                    const isId = this.billDetailForm.issuingParty_label;
                    const sid = this.billDetailForm.signer;
                    return [{id:isId, companyName: this.getCompanyName(isId)},
                        {id:sid, companyName: this.getCompanyName(sid)}]
                }
            }
            return [];
        }
    },
    methods: {
        init(){
            // 取数据判断是走表单，还是PDF.修改showBillLading和showPdf(互斥)
            this.conditionData = this.$routerUtil.getParam();
            // 获取提单信息
            this.billOfLoadingInfo = Object.assign({}, this.conditionData.row);
            if(this.conditionData.row){
                this.billLadingData.shipper = this.conditionData.row.shipper;
                this.billLadingData.consignee = this.conditionData.row.consignee;
                this.billLadingData.notifyParty = this.conditionData.row.notifyParty;
                this.billLadingData.placeOfreceipt = this.conditionData.row.placeOfreceipt;
                this.billLadingData.vessel = this.conditionData.row.vessel;
                this.billLadingData.portOfLoading = this.conditionData.row.portOfLoading;
                this.billLadingData.portOfTransshipment = this.conditionData.row.portOfTransshipment;
                this.billLadingData.PortOfDischarge = this.conditionData.row.PortOfDischarge;
                this.billLadingData.PlaceOfDelivery = this.conditionData.row.PlaceOfDelivery;
                this.billLadingData.freightCharges = this.conditionData.row.freightCharges;
                this.billLadingData.NoOfOriginal = this.conditionData.row.NoOfOriginal;
                this.billLadingData.declared = this.conditionData.row.declared;
                this.billLadingData.voyageNo = this.conditionData.row.voyageNo;
                this.billLadingData.preCarriageBy = this.conditionData.row.preCarriageBy;
                this.billLadingData.planceAndDate = this.conditionData.row.planceAndDate;
                this.billLadingData.forwardingAgent = this.conditionData.row.forwardingAgent;
                this.billLadingData.signedBy = this.conditionData.row.signedBy;
                this.billLadingData.typeOfMovement = this.conditionData.row.typeOfMovement;
                this.billLadingData.blNo = this.conditionData.row.blNo;
                this.billLadingData.finalDestination = this.conditionData.row.finalDestination;
                this.billLadingData.totalNumber = this.conditionData.row.totalNumber;
                this.billLadingData.goodList = this.conditionData.row.billGoods;

                this.billDetailForm.signer = this.conditionData.row.signatureCompanyId;
                this.billDetailForm.issuingParty_label = this.conditionData.row.sendCompanyId;
                this.billDetailForm.billingFee = this.conditionData.row.sendBillFeeCompanyId;
                this.billDetailForm.issuingTime = this.conditionData.row.sendBillDate;
                this.billDetailForm.portOfDischarge = this.conditionData.row.costId;
                this.billDetailForm.billAdditionalDescription = this.conditionData.row.billAdditionalDescription;
                this.billDetailForm.billAdditionalDescriptionOfSend = this.conditionData.row.billAdditionalDescriptionOfSend;
                this.billDetailForm.stdContainerNumber = this.conditionData.row.stdContainerNumber;
                this.billDetailForm.payment = parseInt(this.conditionData.row.payType);
                this.billDetailForm.imageType= this.conditionData.row.billImageName;
                if (this.conditionData.row.billImageName) {
                    if (this.conditionData.row.billImageName.indexOf('bill_image_wiffa.png')!=-1){
                        this.imageType= 1;
                    } else {
                        this.imageType = 2;
                    }
                }

                if (this.conditionData.row.billSignatureFileList) {
                    this.conditionData.row.billSignatureFileList.forEach(file => {
                        if (file.billSignatureFileType === 1) {
                            this.pdfSrc = pdf.createLoadingTask({url: '/api' + file.file, CMapReaderFactory});
                        }
                        if (file.isSignature && file.billSignatureFileType === 1) {
                            this.pdfSrc = pdf.createLoadingTask({url: '/api' + file.file, CMapReaderFactory});
                        }
                    });
                }
                if (this.pdfSrc) {
                    this.pdfSrc.onProgress = progress => {
                        let tempProgress = progress.loaded / progress.total * 100;
                        if(tempProgress > 100){
                            tempProgress = 100;
                        }
                        this.progress = tempProgress;
                        if (this.progress === 100) {
                            setTimeout(() => {
                                this.progressShow = false;
                                for(const key in require.cache) {
                                    if(require && require.cache && require.cache[key] && require.cache[key].exports && require.cache[key].exports.default instanceof Uint8Array){
                                        console.log(key);
                                        delete require.cache[key];
                                    }
                                }
                            }, 500);
                        }
                    };
                    this.loadPdfHandler();
                }
                this.billOfLoadingFileList = this.conditionData.row.billOfLoadingFileList;
                this.billApplyList = this.conditionData.row.billApplyList;
                this.billInvalidApplyList = this.conditionData.row.billInvalidApplyList;

                // 查询当前提单中的收单公司建立合作关系的出单公司下拉列表
                const selectSendCompanyParam = {};
                selectSendCompanyParam.receiveCompanyId = this.conditionData.row.receiveCompanyId;
                this.$axios({
                    method: "get",
                    url: "api/customerCompay/selecCompayCustomer",
                    params: selectSendCompanyParam
                }).then(res => {
                    this.companyList = res.data.resultData;
                }).catch(error => {
                    console.log(error);
                    this.$message({
                        message: this.$t('common.message.operateFail'),
                        type: 'error',
                        center: true
                    });
                });
                // 查询出单费集合下拉
                const param = {};
                // param.isDefault = 0;
                this.$axios.get('/api/cost/selectCostIsDefault',{params:param}).then(response => {
                    this.costList = response.data.resultData;
                }).catch(e => {
                    console.log(e);
                    this.$message({
                        message: this.$t('common.message.operateFail'),
                        type: 'error',
                        center: true
                    });
                });
            }
        },
        loadPdfHandler() {
            this.pdfSrc.promise.then(pdf => {
                this.numPages = pdf.numPages;
            });
        },
        back() {
            this.$routerUtil.setParam(this.conditionData.searchForm);
            if(JSON.parse(sessionStorage.getItem('currentSystem')).code === "1"){
                this.$router.push('Customer-service-bill-lading-manage');
            }else{
                this.$router.push('BillManage');
            }
        },
        getCompanyName(id){
            let companyName = '';
            this.companyList.forEach(item => {
                if(id === item.id){
                    companyName = item.companyName;
                }
            });
            return companyName;
        }
    }
}
